import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var LongAnswerSvg = function LongAnswerSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.008 2H22v1.51H2.008zM2.008 6.717h14.54v1.51H2.008zM21.397 11.434H2.01v1.51h19.387zM2.008 16.15h14.54v1.51H2.008zM13.632 20.49H2V22h11.632z"
  }));
};
export var LongAnswer = function LongAnswer(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: LongAnswerSvg
  }));
};